import { CustomWindow } from '@utils/models/customwindow';
import Player from '@vimeo/player';
import { useBlockMedia } from '@features/Components/VideoBlock/Scripts/video-block';

declare let window: CustomWindow;

// Stage 2: Vimeo
export const useVideoBlockVimeo = () => {
  // When CookieBot consents are changed
  window.addEventListener('CookiebotOnAccept', function() {
    if (window.Cookiebot.consent.marketing) {
      document.querySelectorAll(".video-block__content--vimeo").forEach(element => {
        element.classList.remove("video-block__content--prevent-video");
        element.classList.remove("video-block__content--show-video");
      });
    }
  });

  useBlockMedia().initializeConsentCheck(document.querySelectorAll(".video-block__content--vimeo"));

  document.querySelectorAll(".video-block__content--vimeo").forEach(element => {
    element.addEventListener("click", () => {
      if (!window.Cookiebot.consent.marketing) {
        return;
      }

      element.classList.add("video-block__content--load-video");
      (element.querySelector(".video-block__loading") as HTMLElement)?.classList.remove("hidden");
      const loadingAlert = element?.querySelector(".video-block__hidden-alert") as HTMLDivElement;
      if (loadingAlert) {
        loadingAlert.textContent = loadingAlert.dataset.text as string;
      }

      let iframe: HTMLIFrameElement | null;

      if ((element as HTMLElement).dataset.initialized != "true") {
        iframe = document.createElement("iframe");
        if ((element as HTMLElement).dataset.initialized != "true") {
          const videoId = (element as HTMLElement)?.dataset.videoid;

          // Set the video source to load the video
          iframe.src = `https://player.vimeo.com/video/${videoId}`;
          iframe.classList.add("video-block__player-container");
          iframe.setAttribute("webkitallowfullscreen", "");
          iframe.setAttribute("mozallowfullscreen", "");
          iframe.setAttribute("allowfullscreen", "");

          element?.querySelector(".video-block__player-container")?.appendChild(iframe);
        }
      } else {
        iframe = element.querySelector("iframe");
      }

      const player = new Player(iframe);

      player.on('play', function() {
        (element.querySelector(".video-block__image-wrapper") as HTMLElement).style.visibility = "hidden";
        element?.classList.remove("video-block__content--load-video");
        element?.classList.add("video-block__content--show-video");
        (element.querySelector(".video-block__loading") as HTMLElement)?.classList.add("hidden");
        if (loadingAlert) {
          loadingAlert.textContent = "";
        }
      });

      player.on('pause', function() {
        (element.querySelector(".video-block__image-wrapper") as HTMLElement).style.visibility = "visible";
        element?.classList.remove("video-block__content--show-video");
      });

      // Play the video
      player.play();

      (element as HTMLElement).dataset.initialized = "true";

    });
  });
};